let modals = {
    confirmReceivers: [],
    alertReceivers: [],
    toastReceivers: []
};

export function modalConfirm({type,confirm,cancel,message}){
    return new Promise((resolve,reject) => {
        modals.confirmReceivers.forEach( receiver => receiver({type,confirm,cancel,message,resolve,reject}) );
    });
}

export function modalAlert({type,okay,message,title}){
    modals.alertReceivers.forEach( receiver => receiver({type,okay,message,title}) );
}

export function modalErrors({errors},title=`Required Fields`){
    modalAlert({type:'warning',message:`<div>${Object.values(errors).join('</div><div>')}</div>`,title});
}

export function toast({message,theme}){
    modals.toastReceivers.forEach( receiver => receiver({message,theme}) );
}

export function registerModalReceiver({type,receiver}){
    modals[type+'Receivers'].push(receiver);
}

function formCheck(formData,checks){
    return Object.keys(checks).filter( key => {
        const item = checks[key],
            data = formData[key];
        return !(
            formData.hasOwnProperty(key) && 
            item.validator ? !item.validator(data) :
            item.match && formData.hasOwnProperty(item.match) ? data === formData[item.match] :
            typeof data === 'string' ? item.regex ? item.regex.test(data) : data.split('<p></p>').join('').trim().length > 0 : // Default to empty string check
            Array.isArray(data) ? (data.length >= (item.min || 1)) : 
            typeof data === 'number' ? (data >= (item.min || 0)) :
            !!data );
    }).reduce( (cur, key) => {
        return { 
            ...cur, 
            [key]: checks[key].validator && typeof checks[key].validator(formData[key]) === 'string' ? checks[key].validator(formData[key]) : (typeof checks[key].message === 'function' ? checks[key].message() : checks[key].message ) || true };
    },{});
}

export function formValidator(checks){
    return (formData) => {
        let errors = formCheck(formData,checks);
        return {passed: Object.keys(errors).length === 0, errors};
    }
}

export function backfill(target,promise,props){
    return new Promise((resolve, reject) => {
        promise.then( payload => { 
            resolve(payload);
            return props.forEach( key => target[key] = payload[key] );
        });
    });
}

export function backfillData(props,...lists){
    Object.keys(props).forEach( key => {
        if(typeof props[key] === 'object' && !props[key].hasOwnProperty('initialState')) {
            let initial = {...props[key]};
            Object.defineProperty(props[key], 'initialState', {
                get() {
                    return initial;
                }
            });
        }
    });
    return function(){
        return {...props, ...lists.reduce( (o,list) => ({...o, ...list.reduce( (o,k) => ({...o,[k]:noop.obj}), {} )}), {}) };
    }
}

export function noop(){}

noop.obj = function (){
    return {};
}
noop.str = function(){
    return '';
}
noop.arr = function(){
    return [];
}

export function tryParse(sketchy){
    return new Promise((resolve,reject) => {
        if(typeof sketchy !== 'string') reject();
        try {
            resolve(JSON.parse(sketchy));
        } catch (e) {
            reject();
        }
    });
}

export function pick(props){
    return function(item){
        return props.reduce((obj,prop) => ({...obj,[prop]:item[prop]}),{});
    }
}

export function navigateTo(url){
    let {location} = window;
    return () => {
        if(location.href !== (url.indexOf('://') === -1 ? location.origin : '') + url){
            location.href = url;
        }
    }; 
}

export function wait(seconds){
    return () => new Promise(resolve => setTimeout(resolve,seconds * 1000));
}